import { ApiClient, HttpMethod } from "@/services/apiClient/ApiClient";
import { UserNotFoundException } from "@/services/user/userExceptions";
import { type UserProfile } from "@/services/user/profile/profileTypes";
import type { UserId } from "@/services/user/userTypes";
import { type AxiosError } from "axios";
import { UserProfile_Schema } from "./profileSchema";

export type FetchUserProfileParams = { nickname: string } | { userId: UserId };

export async function fetchUserProfile(params: FetchUserProfileParams): Promise<UserProfile> {
  const url = `api-public/user/collector`;
  return ApiClient.request<UserProfile>({ method: HttpMethod.Get, url, params, sendAnonymousIdentifier: true })
    .then((response) => UserProfile_Schema.parse(response.data))
    .catch((error: AxiosError) => {
      const status = error.response?.status;
      if (status === 404) {
        throw new UserNotFoundException();
      } else {
        throw error;
      }
    });
}
